<app-header></app-header>
<app-menu></app-menu>
<div
  class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 row"
  style="top: 80px"
>
  <div
    class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
    style="
      top: 60px;
      padding-left: 0px;
      padding-right: 0px;
      z-index: 981;
      position: fixed;
      height: 100vh;
      left: 0px !important;
    "
  >
    <div
      class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 row"
      style="
        margin-right: 0px;
        padding-left: 0px;
        margin-left: 0px;
        padding-right: 0px;
      "
    >
      <div
        class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3"
        style="height: 800px; background-color: white"
      >
        <div
          class="
            col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
            row
          "
          style="height: 250px; overflow-y: auto"
        >
          <div
            class="col-md-12 usuariosContent" 
            *ngFor="let activos of ArrayUsuarios"
            style="margin-bottom: 10px; background-color: white;"

          >
            <div class="col-md-12" (click)="OnNuevoMensaje(activos.id)" style="padding-left: 0px;padding-right: 0px;padding-top: 10px;padding-bottom: 10px;">
              <div class="col-md-12 row" style="padding-left: 0%;padding-right: 0%;">
                <div class="col-md-12 row">
                  <div class="col-md-9">
                    <p class="col-md-12" style="color: black;">
                     <img src="../../../assets/inactivo.svg" alt="" *ngIf="activos.estatus == 'inactivo'" style="height: 10px;width: 5px;">
                     <img src="../../../assets/activo.svg" alt="" *ngIf="activos.estatus == 'activo'" style="height: 10px;width: 5px;">
                     <label >{{ activos.plataforma }}</label>
                    </p>
                  </div>

                  <div class="col-md-1">
                    <button
                      mat-raised-button
                      *ngIf="activos.estatus == 'activo'"
                      class="col-md-2"
                      style="margin-left: 1vw"
                    >
                      <mat-icon>settings</mat-icon>
                    </button>
                    <button
                      mat-raised-button
                      class="col-md-2"
                      *ngIf="activos.estatus == 'inactivo'"
                    >
                      <mat-icon>settings</mat-icon>
                    </button>
                  </div>
                </div>
                <div class="col-md-12" style="top: -13px;">
                  <p class="col-md-12" style="color: black;">
                    {{ activos.email }}
                  </p>
                  <p class="col-md-12" style="color: black;">
                    {{ activos.ultimaves | date: "MM/dd/yyyy-hh:mm:ss" }}
                  </p>
                </div>
               
              </div>
            </div>
          </div>
        </div>
        <h2
          class="col-md-12"
          style="
            font-weight: bold;
            text-align: center;
            margin-top: 2vh;
            margin-bottom: 2vh;
          "
        >
          CONVERSATIONS
        </h2>
        <div
          class="
            col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
            row
          "
          style="height: 250px; overflow-y: auto; margin-top: 2vh"
        >
          <div
            class="col-md-12 chatContentSend"
            *ngFor="let chats of ArrayChatsHistorico"
            style="margin-bottom: 10px; background-color: white"
          >
            <div class="col-md-12" *ngFor="let info of chats.registros"  style="padding-left: 0px;padding-right: 0px;padding-top: 10px;padding-bottom: 10px;">
              <div class="col-md-12 row">
                <div class="col-md-12 row">
                  <div
                    class="col-md-12"
                    (click)="OnChangeChatsHistorico(info.chat, info.folio_chat)"
                    style="padding-left: 0%;padding-right: 0%;"
                  >
                  <p class="col-md-12" style="color: black;">
                    <img src="../../../assets/inactivo.svg" alt="" *ngIf="filterDatarStatus(info.folio_chat) == 'inactivo'" style="height: 10px;width: 5px;">
                    <img src="../../../assets/activo.svg" alt="" *ngIf="filterDatarStatus(info.folio_chat) == 'activo'" style="height: 10px;width: 5px;">
                    <label >{{filterDatar(info.folio_chat)}}</label>
                   </p>
                    <p class="col-md-12">
                      
                      {{ chats.usuario }} <br>
                      {{filterDatarDate(info.folio_chat)| date: "MM/dd/yyyy-hh:mm:ss" }}
                       </p>
                       
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="col-xs-9 col-sm-9 col-md-9 col-lg-9 col-xl-9 col-xxl-9 messaging"
        style="
          margin-left: 0px;
          margin-right: 0px;
          margin-top: 0px;
          margin-bottom: 0px;
          padding-bottom: 0px;
          height: 90vh !important;
        "
        *ngIf="contenedorChat"
      >
        <div
          class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
          style="padding-left: 0px; padding-right: 0px"
        >
          <div class="inbox_msg">
            <div class="mesgs">
              <div class="msg_history">
                <div *ngFor="let msg of messages">
                  <div class="incoming_msg" *ngIf="msg.type == 'received'">
                    <div class="incoming_msg_img"></div>
                    <div class="received_msg">
                      <div class="received_withd_msg">
                       
                        <p>
                          {{ msg.message }}
                        </p>
                        <span class="time_date" style="text-align: left;">
                          {{ msg.date | date: "medium" }}
                          <mat-icon>person</mat-icon>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="outgoing_msg" *ngIf="msg.type == 'sent'">
                    <div class="sent_msg">
                      <p>
                        {{ msg.message }}
                      </p>
                      <span class="time_date" style="text-align: right;">
                        {{ msg.date | date: "medium" }} <mat-icon>person</mat-icon></span
                      >
                     
                    </div>
                  </div>
                </div>
              </div>
              <div class="type_msg col-md-12" style="margin-top: 12vh">
                <div
                  class="input_msg_write col-md-12"
                  style="background: white"
                >
                  <input
                    type="text"
                    class="write_msg"
                    [value]="txtMessage"
                    (input)="txtMessage = $event.target.value"
                    (keydown.enter)="sendMessage()"
                    placeholder="Write your message maximum 180 characters"
                    maxlength="180"
                  />
                  <button
                    class="msg_send_btn btn btn-success"
                    type="button"
                    (click)="sendMessage()"
                    style="
                      height: 35px;
                      width: 38px;
                      background: transparent;
                      color: white;
                      left: 65vw;
                      bottom: 0px;
                      top: 6px;
                    "
                  >
                    <mat-icon>send</mat-icon>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<ngx-spinner
  bdColor="rgba(0,0,0,0.07)"
  size="medium"
  color="#2879ff"
  type="square-jelly-box"
  [fullScreen]="true"
>
</ngx-spinner>